import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter, Mutation } from 'vuex-class';
import {
  CUBES_INFO,
  CUBES_INFO_ERRORS,
  CUBES_STATS,
  CUBES_STATS_ERRORS,
  CUBES_STATS_LOADING,
  GET_CUBE_DETAILS,
  GET_CUBES_INFO,
  GET_CUBES_STATS,
  MANAGER_LOADING,
  RESET_EMPLOYEES_FORMS_SEARCH_OBJECT,
  SET_CUBE_SEARCH_OBJECT,
  SET_CUBES_STATS,
  SET_CUBES_STATS_ERRORS,
  SET_CUBES_STATS_LOADING,
} from '@/types/managerForm.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { CubesInfoModel } from '@/models/manager/CubesInfo.model';
import MockData from '@/globals/mock';
import { eventsHub } from '@/main';
import { CubesStatsModel } from '@/models/manager/CubesStats.model';
import { Form101SearchModel } from '@/models/Form101Search.model';
import Spinner from '@/components/loading/Spinner.vue';

@Component({
  components: {
    Spinner,
  },
})
export default class UpdateEmployeesDetailsComponent extends Vue {
  @Action(GET_CUBES_INFO, StoreNamespace.MANAGER) public getCubesInfo;
  @Action(GET_CUBE_DETAILS, StoreNamespace.MANAGER) public getCubeDetails;
  @Action(GET_CUBES_STATS, StoreNamespace.MANAGER) public getCubesStats;

  @Mutation(SET_CUBES_STATS, StoreNamespace.MANAGER) public setCubesStats;
  @Mutation(SET_CUBES_STATS_LOADING, StoreNamespace.MANAGER) public setCubesStatsLoading;
  @Mutation(SET_CUBES_STATS_ERRORS, StoreNamespace.MANAGER) public setCubesStatsErrors;
  @Mutation(RESET_EMPLOYEES_FORMS_SEARCH_OBJECT, StoreNamespace.MANAGER) public resetEmployeesFormsSearchObject;
  @Mutation(SET_CUBE_SEARCH_OBJECT, StoreNamespace.MANAGER) public setCubeSearchObject;

  @Getter(CUBES_INFO, StoreNamespace.MANAGER) public cubesInfo!: CubesInfoModel[];
  @Getter(MANAGER_LOADING, StoreNamespace.MANAGER) public managerLoading!: boolean;
  @Getter(CUBES_INFO_ERRORS, StoreNamespace.MANAGER) public cubesInfoErrors!: string[];
  @Getter(CUBES_STATS, StoreNamespace.MANAGER) public cubesStats!: CubesStatsModel;
  @Getter(CUBES_STATS_LOADING, StoreNamespace.MANAGER) public cubesStatsLoading!: boolean;
  @Getter(CUBES_STATS_ERRORS, StoreNamespace.MANAGER) public cubesStatsErrors!: string[];

  public mockData: any = MockData.groupType;

  public mounted() {
    this.getCubesInfo();
    this.getCubesStats();
  }

  public getCubeDetailsClicked(groupType: string, title: string) {
    this.setCubeSearchObject({} as Form101SearchModel);
    eventsHub.$router.push({ name: 'cube-details', params: { groupType, title } });
  }

  public onCubesStatsClicked(statusCode: string): void {
    this.resetEmployeesFormsSearchObject();
    this.$router.push({ name: 'search-employees', params: { triggerSearch: 'true', statusCode } });
  }

}

